import { Directive } from '@angular/core';
import { getAnimalLabel } from 'src/app/_enums/animal/animal.enum';
import { getCatTypeLabel } from 'src/app/_enums/animal/cat-type.enum';
import { AnimalInsuranceMetadata } from 'src/app/_types/lead.types';

import { BaseMetadataComponent } from '../base-metadata.component';

@Directive()
export class AnimalMetadataComponentAbstract extends BaseMetadataComponent<AnimalInsuranceMetadata> {
  getAnimalType = getAnimalLabel;

  getCatType = getCatTypeLabel;
}
